import { Dialog, DialogFooter, DialogType, Toggle } from "@fluentui/react";
import { Button, notification, Space } from "antd";
import { observer } from "mobx-react-lite";
import AccountStore from "../store/accountStore";
import React, { useContext, useState } from "react";

export const LockOut = observer(() => {
  const accountStore = useContext(AccountStore);
  const user = accountStore.selectedUser;
  const [option, setOption] = useState(user?.isEnabled);
  const [isloading, setIsloading] = useState(false);
  return (
    <Dialog
      hidden={!accountStore.showLockOutDialog}
      onDismiss={() => {
        accountStore.showLockOutDialog = false;
      }}
      dialogContentProps={{
        type: DialogType.close,
        title: "User Access Restriction",
        subText: `${user?.fullName} ${
          user?.isEnabled
            ? `currently have access to the system, toggle the access control button to lock ${user?.firstName.toLowerCase()} out of the system.`
            : ` is currently locked out the system,toggle the access control button to grant ${user?.firstName?.toLowerCase()} access to the system.`
        }`,
      }}
      modalProps={{
        isBlocking: false,
        styles: { main: { maxWidth: 450 } },
        dragOptions: true,
      }}
    >
      <Toggle
        defaultChecked={user?.isEnabled}
        onText="Enable access"
        offText="Restrict access"
        onChange={(ev, option) => {
          setOption(option);
        }}
      />

      <DialogFooter>
        <Space>
          <Button
            type="link"
            onClick={async () => {
              accountStore.showLockOutDialog = false;
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={async () => {
              try {
                setIsloading(true);
                await accountStore.toggleAccess(option, user.id);
                accountStore.showLockOutDialog = false;
                accountStore.userCommandBarDisabled = true;

                notification.success({
                  message: "SPARS Feedback",
                  description: `${user.fullName} has been ${
                    option ? "granted" : "denied"
                  } access sucessfully`,
                });
              } catch (error) {
                notification.info({
                  message: "SPARS Feedback",
                  description: "select user to remove",
                });
              } finally {
                setIsloading(false);
              }
            }}
            loading={isloading}
          >
            OK
          </Button>
        </Space>
      </DialogFooter>
    </Dialog>
  );
});

